import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";


import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
//import { AgmCoreModule } from "@agm/core";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { DragulaModule, DragulaService } from "ng2-dragula";
import { NgxSpinnerModule } from 'ngx-spinner';
/*
import {
  //PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';
*/
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import * as fromApp from './store/app.reducer';
import { AppComponent } from "./app.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";

import { LoginRouteGuard,NotLoginRouteGuard } from "./shared/auth/auth-guard.service";
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { MysqlService } from "./shared/services/mysql/mysql.service";
import { UserService } from "./shared/services/user.service";
import { ArchwizardModule } from "@viso-trust/angular-archwizard";
import { QuillModule } from "ngx-quill";

/*
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};
*/

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({ declarations: [
        AppComponent,
        FullLayoutComponent,
        ContentLayoutComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        StoreModule.forRoot(fromApp.appReducer),
        AppRoutingModule,
        SharedModule,
        ToastrModule.forRoot(),
        NgbModule,
        ArchwizardModule,
        NgxSpinnerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        /*
        AgmCoreModule.forRoot({
          apiKey: "AIzaSyBgbASPQbdzvh_ZUJ17yzGvHbnr7a_OC48",
          libraries: ['places']
        }),*/
        //PerfectScrollbarModule,
        DragulaModule.forRoot(),
        QuillModule.forRoot()], providers: [
        MysqlService,
        UserService,
        LoginRouteGuard,
        NotLoginRouteGuard,
        DragulaService,
        /*
        {
          provide: PERFECT_SCROLLBAR_CONFIG,
          useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        */
        WINDOW_PROVIDERS,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
